import React from 'react';
import { Clock, Phone, Pin, Spinner } from '@vw-marketing/us-components';
import {
  StyledManageDealerInformationItemContainer,
  StyledManageDealerInformationItemsContainer,
  StyledManageDealerOpenClose,
} from './styles';
import { useDealer } from '../../../../app/providers/DealerContext';
import { useMyVwContext } from '../../../../shared/hooks/use-my-vw-context';
import {
  getOpenSchedule,
  ScheduleResult,
} from '../../../../shared/utils/dealer-utils';
import { formatPhoneNumber } from '../../../../shared/utils/general';
import { useFeatureServices } from '../../../../shared/hooks/use-feature-services';

const ManageDealerInformation = () => {
  const {
    userPreferredDealer,
    isLoadingPreferredDealer,
    selectedDepartmentCode,
  } = useDealer();
  const { translationHandler } = useMyVwContext();
  const { 'locale-service': localeService } = useFeatureServices();

  const isCanada = localeService?.countryCode === 'CA';
  const isCanadaFrench = isCanada && localeService?.language === 'fr';
  const locale = isCanadaFrench ? 'fr' : 'en';

  const openCloseStatus: ScheduleResult | null =
    userPreferredDealer?.departments && selectedDepartmentCode
      ? getOpenSchedule(userPreferredDealer.departments, locale, selectedDepartmentCode)
      : null;

  if (isLoadingPreferredDealer) {
    return (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <StyledManageDealerInformationItemsContainer>
      <StyledManageDealerInformationItemContainer>
        <Pin variant="default" />
        {userPreferredDealer?.address?.address1 ? (
          <span className="notranslate">
            {[
              userPreferredDealer.address.address1,
              [userPreferredDealer.address.city, userPreferredDealer.address.state]
                .filter(Boolean)
                .join(', '),
              userPreferredDealer.address.zip,
            ]
              .filter(Boolean)
              .join(' ')}
          </span>
        ) : (
          <span>{translationHandler('dealerManager.details.noAddress')}</span>
        )}
      </StyledManageDealerInformationItemContainer>

      {openCloseStatus && (
        <StyledManageDealerInformationItemContainer>
          <Clock />
          <div style={{ display: 'flex', gap: '4px' }}>
            <StyledManageDealerOpenClose $closed={openCloseStatus.closed}>
              {openCloseStatus.closed
                ? translationHandler('manageDealer.dealerCard.Closed.label')
                : translationHandler('manageDealer.dealerCard.Open.label')}
            </StyledManageDealerOpenClose>
            {'⋅'}
            <span>
              {translationHandler(openCloseStatus.labelKey)}{' '}
              {openCloseStatus.scheduleInfo}
            </span>
          </div>
        </StyledManageDealerInformationItemContainer>
      )}

      <StyledManageDealerInformationItemContainer>
        <Phone />
        {userPreferredDealer?.phone ? (
          <span className="notranslate">
            {formatPhoneNumber(userPreferredDealer.phone).formatted || ''}
          </span>
        ) : (
          <span>{translationHandler('dealerManager.details.noPhone')}</span>
        )}
      </StyledManageDealerInformationItemContainer>
    </StyledManageDealerInformationItemsContainer>
  );
};

export default ManageDealerInformation;
